// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/Aniversariantes_EnviarInput.php
// Do not edit by hand — edit the PHP InputContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

import { registerContract } from './validate'

export interface Aniversariantes_EnviarInput {
cliente_id: number
franquia_id: number
mensagem: string
status?: string
whatsapp_mensagem_id?: number
}

registerContract('Aniversariantes_EnviarInput', {
  cliente_id:           { type: 'number',  required: true },
  franquia_id:          { type: 'number',  required: true },
  mensagem:             { type: 'string',  required: true },
  status:               { type: 'string',  required: false },
  whatsapp_mensagem_id: { type: 'number',  required: false },
})
